import React from 'react'
import ProjectInfo from '../ProjectInfo'


import behindchange from "../../../../Assets/images/projects/behindchangedetailed.png"



export default function BehindChange() {
    return (
        <ProjectInfo pic={behindchange}
            title="Behind Change Website"
            maincolor="#2a37b4"
            accentcolor="#1586cc"
            link="https://behind-change.netlify.app/"
            githublink="https://github.com/Jrwolf99/Behind-Change-Website-React"
        >

            <p > This is a website designed to market the Behind Change initiative. Under the slogan "Positive Impact Deserves Positive Support", Behind Change is meant to assist non-profits and businesses with positive impacts in their technological endeavors.</p>
            <br />
            <p>Created with React, animated by Framer Motion.</p>
            <br />


        </ProjectInfo >)
}
